
import { Expose, Type } from "class-transformer";
import { GeoJSONGeometry } from "ol/format/GeoJSON";

export class CarDTO {

  public point: number[] = [0.0, 0.0];

  @Expose({ name: "rural_code" })
  public ruralCode!: string;

  @Type(() => RuralInfo)
  @Expose({ name: "rural_info" })
  public ruralInfo!: RuralInfo[];

  @Expose({ name: "rural_type" })
  public ruralType!: string;
}

export class RuralInfo {
  public condicao!: string;

  public geom!: GeoJSONGeometry;
  
  @Expose({ name: "rural_code" })
  public ruralCode!: string;
  public situacao!: string;

  @Expose({ name: "tipo_imovel" })
  public tipoImovel!: string;
  
}

export class CarNearArrayDTO {
  cars!: Array<CarNearDTO>;
}

export class CarNearDTO {
  public geom!: GeoJSONGeometry;
  @Expose({ name: 'rural_code' })
  public ruralCode!: string;
}

